(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-custom-highlights"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".scroll-pills__items");
  
  wrappers.forEach(wrapper => {
    function adjustAlignment() {
      if (wrapper.scrollWidth <= wrapper.clientWidth) {
        wrapper.style.justifyContent = "center";
      } else {
        wrapper.style.justifyContent = "flex-start";
      }
    }
    adjustAlignment();
    window.addEventListener("resize", adjustAlignment);
  });
});


  } catch(e) { console.error(e); }
})();
})();
